module.exports = __webpack_public_path__ + "img/160-northern-marianas-islands.08e4708b.svg";